import { isSaaSSubdomain } from 'utils/getSubdomain';

export const AUTH_CRED = 'AUTH_CRED';
export const AUTH_TOKEN_KEY = process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY ?? 'authToken';
const saas = isSaaSSubdomain() ? '/saas' : '';

const SAAS_ROUTES = (prefix: string) => {
  return {
    TENANT_REQUEST: {
      BASE: `${prefix}/tenant-requests`,
      DELETE: (id: string) => `${prefix}/tenant-requests/${id}`,
      GET_BY_ID: (id: string) => `${prefix}/tenant-requests/${id}`,
      GET_BY_STATUS: (status: string) => `${prefix}/tenant-requests/status/${status}`,
      EXISTS: (id: string) => `${prefix}/tenant-requests/exists/${id}`,
      COUNT: `${prefix}/tenant-requests/count`,
      FIND: `${prefix}/tenant-requests/find`,
      APPROVE: (id: string) => `${prefix}/tenant-requests/${id}/approve`,
      REJECT: (id: string) => `${prefix}/tenant-requests/${id}/reject`,
    },
    TENANTS: {
      BASE: `${prefix}/tenants`,
    },
    CATALOG_ITEMS: {
      BASE: `${prefix}/global-catalog-items`,
      GET_BY_ID: (id: string) => `${prefix}/global-catalog-items/${id}`,
    },
    SHARED_CATEGORIES: {
      BASE: `${prefix}/shared-categories`,
      GET_BY_ID: (id: string) => `${prefix}/shared-categories/${id}`,
    },
    ITEM_UNITS: {
      BASE: `${prefix}/catalog-item-units`,
      GET_BY_ID: (id: string) => `${prefix}/catalog-item-units/${id}`,
    },
  };
};

const TENANT_ROUTES = (prefix: string) => {
  return {
    TENANT_REQUEST: {
      SEND_TENANT_REQUEST: `${prefix}/tenant-requests`,
    },
    TENANTS: {
      BASE: `${prefix}/tenants`,
    },
    BUSINESS: {
      GET_BY_ID: `${prefix}/business/:tenantId`,
      UPDATE_SETTINGS: (id: string) => `${prefix}/business/${id}/settings`,
      UPLOAD_IMAGE: (businessId: string) => `${prefix}/business/${businessId}/upload-image`,
    },
    SHOPS: {
      BASE: `${prefix}/shops`,
      WITH_ID: `${prefix}/shops/:id`,
      PATCH: `${prefix}/shops/:id`,
      UPLOAD_IMAGE: (shopId: string) => `${prefix}/shops/${shopId}/upload-image`,
    },
    SHOP_ITEMS: {
      BASE: `${prefix}/shop-items`,
      WITH_ID: `${prefix}/shop-items/:id`,
      PATCH: `${prefix}/shop-items/:id`,
    },
    ITEM_UNITS: {
      BASE: `${prefix}/item-units`,
      WITH_ID: `${prefix}/item-units/:id`,
      BY_CATEGORY: `${prefix}/item-units/category/:category`,
    },
    PURCHASES: {
      BASE: `${prefix}/purchase-invoices`,
      WITH_ID: `${prefix}/purchase-invoices/:id`,
      PATCH: `${prefix}/purchase-invoices/:id`,
      ADJUSTMENTS: `${prefix}/purchase-invoices/:id/adjustments`,
      PAGINATED: `${prefix}/purchase-invoices/shop/:shopId/paginated`,
      ADJUSTMENT_ITEMS_PAGINATED: `${prefix}/purchase-invoices/shop/:shopId/adjustments/items/paginated`,
    },
    ADJUSTMENTS: {
      BASE: `${prefix}/adjustments`,
      WITH_ID: `${prefix}/adjustments/:id`,
    },
    SELLS: {
      BASE: `${prefix}/sell-invoices`,
      WITH_ID: `${prefix}/sell-invoices/:id`,
      BY_SHOP_ID: `${prefix}/sell-invoices/:shopId/sells`,
      ADJUSTMENTS: `${prefix}/sell-invoices/:id/adjustments`,
      PAGINATED: `${prefix}/sell-invoices/shop/:shopId/paginated`,
      ADJUSTMENT_ITEMS_PAGINATED: `${prefix}/sell-invoices/shop/:shopId/adjustments/items/paginated`,
    },
    INVENTORIES: {
      BASE: `${prefix}/inventories`,
      SHOP_BASE: `${prefix}/inventories/shop/:shopId`,
      PAGINATED: `${prefix}/inventories/shop/:shopId/paginated`,
      PATCH: `${prefix}/inventories/shop/:shopId/item/:shopItemId`,
      GET_BY_SHOP_ITEM: `${prefix}/inventories/shop/:shopId/item/:itemId`,
    },
    MANUFACTURERS: {
      BASE: `${prefix}/manufacturers`,
      WITH_ID: `${prefix}/manufacturers/:id`,
      PATCH: `${prefix}/manufacturers/:id`,
    },
    USERS: {
      BASE: `${prefix}/users`,
      WITH_ID: `${prefix}/users/:id`,
      PATCH: `${prefix}/users/:id`,
    },
    ROLES: {
      BASE: `${prefix}/roles`,
      WITH_ID: `${prefix}/roles/:id`,
      PERMISSIONS_CATALOG: `${prefix}/roles/permissions/catalog`,
      UPDATE_PERMISSIONS: (id: string) => `${prefix}/roles/${id}/permissions`,
    },
    STAFF: {
      BASE: `${prefix}/staff`,
      WITH_ID: `${prefix}/staff/:id`,
      PAGINATED: `${prefix}/staff/paginated`,
      BY_SHOP: (shopId: string) => `${prefix}/staff/shop/${shopId}`,
      CHANGE_ROLE: (id: string) => `${prefix}/staff/${id}/role`,
      ASSIGN_SHOP: (id: string) => `${prefix}/staff/${id}/assign-shop`,
      UNASSIGN_SHOP: (id: string) => `${prefix}/staff/${id}/unassign-shop`,
      RESET_PASSWORD: (id: string) => `${prefix}/staff/${id}/reset-password`,
      CHANGE_PASSWORD: (id: string) => `${prefix}/staff/${id}/change-password`,
      DEACTIVATE: (id: string) => `${prefix}/staff/${id}/deactivate`,
      REACTIVATE: (id: string) => `${prefix}/staff/${id}/reactivate`,
      MY_PERMISSIONS: `${prefix}/staff/me/permissions`,
    },
    LEDGERS: {
      PAGINATED: `${prefix}/ledgers/shop/:shopId/paginated`,
    },
    STOCK_MOVEMENTS: {
      PAGINATED: `${prefix}/stock-movements/shop/:shopId/paginated`,
    },
  };
};

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: `/api${saas}/auth/register`,
    LOGIN: `/api${saas}/auth/login`,
    CHECK_IDENTIFIER: `/api/saas/auth/check-identifier`,
    VERIFY_2FA: `/api${saas}/auth/verify-2fa`,
    REFRESH: `/api${saas}/auth/refresh`,
    FORGET_PASSWORD: `/api${saas}/auth/forgot-password`,
    RESET_PASSWORD: `/api${saas}/auth/reset-password`,
    LOGOUT: `/api${saas}/auth/logout`,
    SESSIONS: '/api/saas/auth/sessions',
    REVOKE_SESSIONS: '/api/saas/auth/revoke-sessions',
    ME: `/api${saas}/auth/me`,
  },
  SAAS: SAAS_ROUTES('/api/saas'),
  TENANT: TENANT_ROUTES('/api'),
};
